import { render, staticRenderFns } from "./ProgramSoc.vue?vue&type=template&id=e11477ea"
import script from "./ProgramSoc.vue?vue&type=script&lang=js"
export * from "./ProgramSoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports